export default __webpack_public_path__ + "static/media/icon-facebook.8251f781.svg";